var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeLogoVeyeV(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1",
    "data-name": "Grupo 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.408,
    height: 25.124,
    viewBox: "0 0 30.408 25.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    cx: 2.709,
    cy: 2.709,
    r: 2.709,
    transform: "translate(24.99 9.819)",
    fill: "#36d896"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M1054.465,494.045c.441,2.934,2.594,14.993,9.315,24.219a.587.587,0,0,0,.474.24h3.993a.587.587,0,0,0,.474-.24c6.72-9.226,8.874-21.285,9.314-24.219a.578.578,0,0,0-.572-.665h-3.185a.576.576,0,0,0-.573.5c-.327,2.415-2.032,13.1-7.455,20.827-5.423-7.729-7.128-18.412-7.455-20.827a.575.575,0,0,0-.573-.5h-3.185A.578.578,0,0,0,1054.465,494.045Z",
    transform: "translate(-1054.458 -493.38)",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeLogoVeyeV);
export default __webpack_public_path__ + "static/media/icone-logo-veye-v.be69559af3eb8138c83431c69eeb6341.svg";
export { ForwardRef as ReactComponent };